exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-23e3b813]{font-size:15px;line-height:1.35}@media screen and (min-width:360px){.text[data-v-23e3b813]{font-size:18px;line-height:1.4}}.text__title[data-v-23e3b813]{color:#484848}.text__value[data-v-23e3b813]{font-weight:700}.text__info[data-v-23e3b813]{color:red;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23e3b813","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/certificate/components/data/components/text/Text.vue
// module id = 89bb638748c48ac65937
// module chunks = 9